import { PolicySeverity } from '../../types/policies';

import { Flame, AlertTriangle, AlertCircle, Info } from 'lucide-react';

interface SeverityFilterProps {
  selectedSeverity: PolicySeverity | null;
  onSeverityChange: (severity: PolicySeverity | null) => void;
}

const severities: { value: PolicySeverity; icon: typeof Flame; color: string }[] = [
  { value: 'Critical', icon: Flame, color: 'text-rose-500' },
  { value: 'High', icon: AlertTriangle, color: 'text-orange-500' },
  { value: 'Medium', icon: AlertCircle, color: 'text-amber-500' },
  { value: 'Low', icon: Info, color: 'text-sky-500' },
];

export const SeverityFilter = ({ selectedSeverity, onSeverityChange }: SeverityFilterProps) => {
  return (
    <div className="flex items-center gap-2 lg:gap-4 p-1.5 bg-muted/30 rounded-xl">
      {severities.map(({ value, icon: Icon, color }) => (
        <button
          key={value}
          onClick={() => onSeverityChange(selectedSeverity === value ? null : value)}
          className={`relative flex items-center justify-center gap-2 px-4 py-1.5 rounded-lg text-[13px] font-medium transition-all duration-300 ${
            selectedSeverity === value
              ? 'bg-gradient-to-br from-card to-card/80 text-foreground shadow-sm ring-1 ring-border/50 scale-105'
              : 'text-muted-foreground hover:text-foreground hover:bg-card/50 hover:scale-105'
          }`}
        >
          <Icon className={`h-4 w-4 transition-all duration-300 ${color} ${selectedSeverity === value ? '' : 'opacity-40'}`} />
          {value}
        </button>
      ))}
    </div>
  );
};
